<template>
  <button
    class="btn btn-box btn-release"
    v-b-tooltip="__('Liberar para área comercial')"
    v-if="!leadReleased && !loading"
    @click="open()"
  >
    <i class="fa fa-thumbs-o-up" />
    <BModal
      modal-class="modal-width-380"
      :ref="'modal-'+modalClass"
    >
      <template slot="modal-title">
        {{ __('Liberar') }} {{ name }}
      </template>
      <template slot="default">
        <div class="form-group">
          <label>{{ __('Selecione o vendedor') }}</label>
          <select
            class="form-control"
            v-model="owner"
          >
            <option value="">
              {{ __('Selecione') }}
            </option>
            <option
              v-for="user in users"
              :value="user.id"
              :key="user.id"
            >
              {{ user.first_name }} ({{ user.email }})
            </option>
          </select>
        </div>
      </template>
      <template slot="modal-footer">
        <button
          class="btn"
          type="button"
          @click="modal('hide')"
        >
          Cancelar
        </button>
        <button
          class="btn btn-box"
          type="button"
          @click="release()"
          :disabled="loading || ! owner"
        >
          <span v-if="loading">{{ __('Salvando') }}...</span><span v-if="!loading">{{ __('Liberar') }}</span>
        </button>
      </template>
    </BModal>
  </button><i
    class="fa fa-circle-o-notch fa-spin"
    v-else-if="loading"
  />
</template>

<script>
import { BModal, VBTooltip } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  props: ['name', 'hash', 'released'],

  store: ['users'],

  data () {
    return {
      loading: false,
      owner: '',
      leadReleased: (() => !! this.released)(),
      modalClass: `release-${this.hash}`,
    };
  },

  methods: {
    release () {
      this.loading = true;

      const data = {
        release: true,
        owner: this.owner,
      };

      this.$http.put(`/lead/${this.hash}`, data)
        .then(() => {
          this.loading = false;
          this.leadReleased = true;
          this.close();
        });
    },

    open () {
      if (this.users.length) {
        return this.modal('show');
      }

      this.release();
      this.dropTooltip();
    },

    close () {
      this.modal('hide');
    },

    modal (visibility) {
      if (visibility == 'show') {
        this.$refs[`modal-${this.modalClass}`].show();

        return;
      }

      this.$refs[`modal-${this.modalClass}`].hide();
    },

    dropTooltip () {
      this.$root.$emit('bv::hide::tooltip');
    },
  },
};
</script>
